import React from 'react';
import { StoryblokComponent, storyblokEditable } from 'gatsby-source-storyblok';
import ButtonLink from '../../buttons/button_link';

const CompassResortCard = ({ blok, percent, isTop }) => {
  const img =
    blok.image?.length > 0 ? <StoryblokComponent blok={blok.image[0]} /> : null;
  const links = blok.link?.map((link, index) => (
    <ButtonLink blok={link} key={link._uid || `link-${index}`} />
  ));

  if (isTop) {
    return (
      <div
        className="col-span-12 md:col-span-8 grid grid-cols-12 relative mt-4 bg-yellow-15 rounded-lg overflow-hidden"
        {...storyblokEditable(blok)}
      >
        <div className="col-span-12 md:col-span-5 relative aspect-4/3 md:aspect-auto md:min-h-[220px]">
          {img}
        </div>
        <div className="col-span-12 md:col-span-7 p-4 flex flex-col gap-2">
          <p className="text-sm uppercase tracking-wide">Bästa matchning</p>
          <h3 className="font-crystalCondensed text-2xl">{blok.title}</h3>
          <p className="text-3xl font-semibold">{percent}%</p>
          {blok.short_text ? <p>{blok.short_text}</p> : null}
          <div className="mt-auto">{links}</div>
        </div>
      </div>
    );
  }

  return (
    <div
      className="col-span-12 grid grid-cols-12 items-center gap-3 py-3 border-b border-gray-200"
      {...storyblokEditable(blok)}
    >
      <div className="col-span-8 md:col-span-9">
        <div className="flex justify-between gap-2 mb-1">
          <span className="font-medium">{blok.title}</span>
          <span className="tabular-nums">{percent}%</span>
        </div>
        <div
          className="h-2 w-full bg-gray-100 rounded overflow-hidden"
          role="presentation"
        >
          <div
            className="h-full bg-black rounded"
            style={{ width: `${Math.min(100, Math.max(0, percent))}%` }}
          />
        </div>
      </div>
      <div className="col-span-4 md:col-span-3 flex justify-end">{links}</div>
    </div>
  );
};

export default CompassResortCard;
